import { useState } from "react";
import { Container, Row, Col, Form, Button, ToastContainer } from "react-bootstrap";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import { GetDateNow, GetTimeNow } from "../../utils/DataUtils";
import toast from "react-hot-toast";

export const Portaria = () => {
  const [peopleId, setPeopleId] = useState("");
  const [company, setCompany] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [editable, setEditable] = useState(false);
  const [document, setDocument] = useState("");
  const [badge, setBadge] = useState("");
  const [doc, setDoc] = useState("");
  const [obs, setObs] = useState("");
  const [service, setService] = useState("");
  const [local, setLocal] = useState("");
  const [responsible, setResponsible] = useState("");
  const [plate, setPlate] = useState("");


  const locales = [
    "ADM", "ALMOXARIFADO", "AMBULATORIO", "AREA EXTERNA", "AREA TOTAL", "BRIGADA",
    "CAMPO", "COLETA", "CONTABILIDADE", "CONTROLADORIA", "COZINHA", "CT",
    "DEPOSITO VIDROS", "ENGENHARIA", "ESTACIONAMENTO", "ESTAMPARIA", "ESTAÇÃO AGUA",
    "EXPORTAÇAO", "FABRICA", "FERRAMENTARIA", "FINANCEIRO", "FISCAL", "FUNDOS AGP",
    "GAS", "IMPORTAÇAO", "JARDIM", "JURIDICO", "LABORATORIO", "LIMPEZA",
    "LOGISTICA", "MANUTENÇÃO", "MERCADO", "OBRA", "PASSAGEIROS", "PERICIA",
    "PORTARIA", "QUALIDADE", "RECEPÇÃO", "RESIDUO", "RH", "SALA LIMPA",
    "SEG TRABALHO", "SERVIÇOS", "TI", "TREINAMENTO", "USINAGEM"
  ];

  const limparCampos = () => {
    setPeopleId("");
    setCompany("");
    setName("");
    setPhone("");
    setEditable(false);
    setService("");
    setLocal("");
    setResponsible("");
    setPlate("");
    setObs("");
    setBadge("");
    setDoc("");
  };

  const buscarPessoa = async () => {

    if (!document.trim()) return;

    try {
      const { data } = await blogFetch.get(`/Entry/filter/${document}`);


      // Setar dados da pessoa
      setDocument(data.people.peA_cpf || "");
      setPeopleId(data.people.peA_PK_idPeople || "");
      setCompany(data.people.peA_company || "");
      setName(data.people.peA_Name || "");
      setPhone(data.people.peA_phone || "");

      // Setar dados da entrada
      setService(data.etR_typeService || "");
      setLocal(data.etR_local || "");
      setResponsible(data.etR_responsible || "");
      setPlate(data.etR_licensePlate || "");

      setEditable(true);

    } catch (error) {
      console.error("Erro ao buscar pessoa:", error);
      setEditable(false);
      setDocument(document)
      limparCampos();
    }
  };


  const salvarPessoa = async () => {
    const payload = {
      PEA_Name: name,
      PEA_cpf: document,
      PEA_phone: phone,
      PEA_company: company,
    };

    try {
      const { data } = await blogFetch.post("/people", payload);
      return data.peA_PK_idPeople;
    } catch (error) {
      return null;
    }
  };

  const salvarEntrada = async (id) => {

    const data = {
      ETR_FK_peopleId: id,
      ETR_licensePlate: plate,
      ETR_badge: badge,
      ETR_responsible: responsible,
      ETR_data: GetDateNow(),
      ETR_checkin: GetTimeNow(),
      ETR_typeService: service,
      ETR_local: local,
      ETR_doc: doc,
      ETR_obs: obs,
    };

    try {
      await blogFetch.post("/entry", data);
    } catch (error) {
    } finally {
      limparCampos();
    }
  };

  const handleSalvar = async () => {
    if (!name || !document || !company) {
      toast.error("Preencha todos os campos obrigatórios!");
      return;
    }

    let id = peopleId;
    if (!editable) {
      id = await salvarPessoa();
      if (!id) {
        toast.error("Erro ao salvar os dados da pessoa.");
        return;
      }
    }

    try {
      await salvarEntrada(id);
      toast.success("Entrada cadastrada com sucesso!");
    } catch (error) {
      toast.error("Erro ao salvar entrada.");
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <div className="app_body">
        <ToastContainer position="top-right" autoClose={3000} />
        <Container className="mt-6 justify-center">
          <div className="p-4 shadow-sm">
            <h3 className="text-center mb-4 fw-bold">Cadastro de Visitantes</h3>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
                  e.preventDefault();
                }
              }}
            >
              <Row className="g-3">
                <Col md={4}>
                  <Form.Group className="d-flex gap-2">
                    <Form.Control
                      type="text"
                      placeholder="CPF/RG"
                      required
                      value={document}
                      onChange={(e) => setDocument(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          buscarPessoa();
                        }
                      }}
                    />
                    <Button variant="outline-secondary" onClick={buscarPessoa}>
                      Buscar
                    </Button>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Nome"
                    value={name}
                    disabled={editable}
                    required
                    onChange={(e) => setName(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Telefone"
                    className={editable ? "bg-slate-400" : ""}
                    value={phone}
                    disabled={editable}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Empresa"
                    required
                    className={editable ? "bg-slate-400" : ""}
                    disabled={editable}
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Responsável"
                    value={responsible}
                    onChange={(e) => setResponsible(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Placa"
                    value={plate}
                    onChange={(e) => setPlate(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Select value={local} onChange={(e) => setLocal(e.target.value)}>
                    <option value="">Local</option>
                    {locales.map((loc, i) => (
                      <option key={i} value={loc}>{loc}</option>
                    ))}
                  </Form.Select>
                </Col>

                <Col md={4}>
                  <Form.Select value={service} onChange={(e) => setService(e.target.value)}>
                    <option value="">Motivo</option>
                    <option value="Coleta">Coleta</option>
                    <option value="Entrega">Entrega</option>
                    <option value="Visita">Visita</option>
                    <option value="Serviço">Serviço</option>
                  </Form.Select>
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Crachá"
                    value={badge}
                    onChange={(e) => setBadge(e.target.value)}
                  />
                </Col>

                <Col md={6}>
                  <Form.Control
                    placeholder="NF/Requisição"
                    value={doc}
                    onChange={(e) => setDoc(e.target.value)}
                  />
                </Col>

                <Col md={6}>
                  <Form.Control
                    placeholder="OBS"
                    value={obs}
                    onChange={(e) => setObs(e.target.value)}
                  />
                </Col>

                <Col xs={12} className="text-end mt-3">
                  <Button variant="primary" className="px-5" onClick={handleSalvar}>
                    Salvar
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Container>
      </div>
    </>
  );
};
